import Breadcrumb from '@/components/base/Breadcrumb';
import { testimonials } from '@/mocks/homeData';
import { useEffect } from 'react';

const aboutFAQ = [
  {
    question: '虚空韩漫网是什么？',
    answer: '虚空韩漫网是一个专注于韩国漫画在线阅读的中文平台，为华语读者提供海量无删减韩漫内容。我们拥有八千余部韩漫作品，涵盖恋爱、奇幻、动作、恐怖等多种题材，所有内容完全免费。',
  },
  {
    question: '虚空韩漫网有哪些优势？',
    answer: '我们的核心优势包括：全网最快的更新速度、高清无损的漫画画质、完全无删减的内容呈现、便捷的下拉式阅读体验、以及丰富完善的分类导航系统。我们的翻译团队专业高效，确保读者获得最佳的阅读体验。',
  },
  {
    question: '如何联系虚空韩漫网？',
    answer: '您可以通过本页面的联系表单与我们取得联系。我们的客服团队会在24小时内回复您的咨询。您也可以通过页面底部的社交媒体渠道关注我们，获取最新动态。',
  },
];

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们-虚空韩漫网_韩漫在线阅读平台介绍';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', '了解虚空韩漫网——领先的韩漫在线阅读平台。提供八千余部无删减韩国漫画免费阅读，每日实时更新。品牌故事、用户口碑、联系方式，尽在虚空韩漫网关于我们页面。');
    const keywordsMeta = document.querySelector('meta[name="keywords"]');
    if (keywordsMeta) keywordsMeta.setAttribute('content', '虚空韩漫网,关于我们,韩漫平台,免费韩漫,漫画网站介绍');
  }, []);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '虚空韩漫网',
      url: 'http://nh5688.com/',
      description: '虚空韩漫网是领先的韩漫在线阅读平台，提供八千余部无删减韩国漫画免费阅读。',
      foundingDate: '2020',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
      sameAs: [],
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.innerHTML = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: aboutFAQ.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer,
        },
      })),
    });
    document.head.appendChild(faqScript);
    return () => {
      document.head.removeChild(faqScript);
    };
  }, []);

  return (
    <div className="min-h-screen pt-16">
      <div className="px-4 md:px-6 py-8 md:py-12">
        <div className="max-w-4xl mx-auto">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="mt-8 mb-16" aria-labelledby="brand-title">
            <h1 id="brand-title" className="font-heading text-3xl md:text-4xl text-foreground-950 mb-6">
              关于<span className="text-primary-500">虚空韩漫</span>
            </h1>

            <div className="bg-background-100 rounded-2xl p-6 md:p-8 mb-8">
              <h2 className="font-heading text-xl text-foreground-950 mb-4">品牌故事</h2>
              <div className="text-foreground-700 text-sm leading-relaxed space-y-4">
                <p>
                  虚空韩漫网创立于2020年，由一群热爱韩国漫画的资深读者共同创建。我们深知华语读者对优质韩漫内容的渴望——不仅要快，还要全；不仅要全，还要无删减。
                </p>
                <p>
                  正是基于这样的初心，虚空韩漫网从创立之初就坚持<strong>免费、无删减、实时更新</strong>三大原则。我们的翻译团队由数十位精通韩语的专业译者组成，全天候跟踪韩国原作更新进度，确保读者能第一时间看到最新汉化章节。
                </p>
                <p>
                  经过数年的发展，虚空韩漫网已成长为华语地区<strong>最具影响力的韩漫阅读平台之一</strong>。我们收录了超过八千部韩国漫画作品，涵盖恋爱、奇幻、武侠、恐怖、悬疑、科幻等十余种题材分类，累计章节超过十二万话，日均服务读者超过五十万人次。
                </p>
                <p>
                  我们始终坚信，<strong>好的漫画值得被更多人看到</strong>。虚空韩漫网将继续秉持初心，为华语读者提供最优质的韩漫阅读体验。无论你是韩漫新手还是资深漫迷，虚空韩漫网都欢迎你的到来。
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8">
              <div className="bg-background-100 rounded-xl p-6 text-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 mx-auto mb-4">
                  <i className="ri-book-open-line text-2xl text-primary-600"></i>
                </div>
                <p className="font-heading text-2xl text-foreground-950 mb-1">8,500+</p>
                <p className="text-foreground-500 text-xs">漫画作品</p>
              </div>
              <div className="bg-background-100 rounded-xl p-6 text-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 mx-auto mb-4">
                  <i className="ri-user-heart-line text-2xl text-accent-600"></i>
                </div>
                <p className="font-heading text-2xl text-foreground-950 mb-1">200万+</p>
                <p className="text-foreground-500 text-xs">注册用户</p>
              </div>
              <div className="bg-background-100 rounded-xl p-6 text-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-secondary-100 mx-auto mb-4">
                  <i className="ri-timer-flash-line text-2xl text-secondary-600"></i>
                </div>
                <p className="font-heading text-2xl text-foreground-950 mb-1">24小时</p>
                <p className="text-foreground-500 text-xs">更新保障</p>
              </div>
            </div>
          </section>

          <section className="mb-16" id="testimonials" aria-labelledby="reputation-title">
            <h2 id="reputation-title" className="font-heading text-2xl md:text-3xl text-foreground-950 mb-8">
              用户<span className="text-primary-500">口碑</span>
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {testimonials.map((item) => (
                <article
                  key={item.id}
                  className="bg-background-100 rounded-xl p-5"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {[...Array(item.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <blockquote className="text-foreground-700 text-sm leading-relaxed mb-4">
                    &ldquo;{item.content}&rdquo;
                  </blockquote>
                  <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-10 h-10 rounded-full object-cover"
                      loading="lazy"
                    />
                    <div>
                      <p className="text-foreground-900 text-sm font-medium">{item.name}</p>
                      <p className="text-foreground-500 text-xs">{item.role}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </section>

          <section className="mb-16" id="contact" aria-labelledby="contact-title">
            <h2 id="contact-title" className="font-heading text-2xl md:text-3xl text-foreground-950 mb-8">
              联系<span className="text-primary-500">我们</span>
            </h2>

            <div className="bg-background-100 rounded-2xl p-6 md:p-8">
              <p className="text-foreground-600 text-sm mb-6">
                如果您有任何问题、建议或合作意向，请通过以下表单与我们联系。我们的客服团队将在24小时内回复您。
              </p>

              <form
               
                id="contact-form"
                className="space-y-5"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const form = e.currentTarget as HTMLFormElement;
                  const formData = new FormData(form);

                  const honeypot = formData.get('website_alt') as string;
                  if (honeypot && honeypot.trim() !== '') {
                    alert('提交成功！感谢您的留言，我们会尽快回复。');
                    form.reset();
                    return;
                  }

                  try {
                    const response = await fetch('http://nh5688.com/', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                      body: new URLSearchParams(
                        Array.from(formData.entries())
                          .filter(([key]) => key !== 'website_alt')
                          .map(([k, v]) => [k, v.toString()])
                      ).toString(),
                    });

                    const responseText = await response.text();
                    let parsed;
                    try { parsed = JSON.parse(responseText); } catch { parsed = null; }

                    if (response.ok && parsed?.code === 'OK') {
                      alert('提交成功！感谢您的留言，我们会尽快回复。');
                      form.reset();
                    } else {
                      const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
                      alert(serverMsg || '提交失败，请稍后重试。');
                    }
                  } catch {
                    alert('网络错误，请稍后重试。');
                  }
                }}
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="contact-name" className="block text-foreground-700 text-sm font-medium mb-1.5">
                      您的姓名 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      id="contact-name"
                      name="name"
                      type="text"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-foreground-700 text-sm font-medium mb-1.5">
                      电子邮箱 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      id="contact-email"
                      name="email"
                      type="email"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="contact-subject" className="block text-foreground-700 text-sm font-medium mb-1.5">
                    主题
                  </label>
                  <input
                    id="contact-subject"
                    name="subject"
                    type="text"
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请简要描述您的问题"
                  />
                </div>
                <div>
                  <label htmlFor="contact-message" className="block text-foreground-700 text-sm font-medium mb-1.5">
                    留言内容 <span className="text-primary-500">*</span>
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                    placeholder="请输入您的留言内容（最多500字）"
                  ></textarea>
                  <p className="text-foreground-400 text-xs mt-1">最多500个字符</p>
                </div>

                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="honeypot-field"
                />

                <button
                  type="submit"
                  className="px-8 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  提交留言
                </button>
              </form>
            </div>
          </section>

          <section className="mb-16" aria-labelledby="faq-title">
            <h2 id="faq-title" className="font-heading text-2xl md:text-3xl text-foreground-950 mb-8">
              常见<span className="text-primary-500">问题</span>
            </h2>
            <div className="space-y-3">
              {aboutFAQ.map((item, index) => (
                <details
                  key={index}
                  className="group bg-background-100 rounded-xl overflow-hidden"
                >
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-200/50 transition-colors">
                    <span className="text-foreground-800 text-sm font-medium pr-4">
                      {item.question}
                    </span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform shrink-0"></i>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-foreground-600 text-sm leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </details>
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}